export default "__VITE_ASSET__N_6McPDk__"